import { render } from "./FeatureDeleteConfirmationModal.vue?vue&type=template&id=2a49a410"
import script from "./FeatureDeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./FeatureDeleteConfirmationModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2a49a410"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a49a410', script)) {
    api.reload('2a49a410', script)
  }
  
  module.hot.accept("./FeatureDeleteConfirmationModal.vue?vue&type=template&id=2a49a410", () => {
    api.rerender('2a49a410', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/FeatureDeleteConfirmationModal.vue"

export default script